export default __webpack_public_path__ + "static/media/ColorNotification.c2810f08.svg";